<!--
Copyright 2021 The Ground Authors.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

<div class="job-list-item-container">
  <div class="job-tree-node">
    @if (isSidePanelExpanded()) {
      @if (hasLois()) {
        <button
          type="button"
          class="expand-toggle"
          [class.expanded]="expanded()"
          [attr.aria-expanded]="expanded()"
          [attr.aria-label]="'Toggle ' + job().name"
          (click)="toggleExpanded()"
        >
          <mat-icon class="mat-icon-rtl-mirror expand-toggle-icon"
            >arrow_right</mat-icon
          >
        </button>
      }

      <div class="job-tree-node-label">
        <mat-icon
          class="job-icon"
          fontSet="material-icons"
          [style.color]="job().color"
        >
          label
        </mat-icon>

        <div class="job-name">{{ job().name }}</div>
      </div>

      <div class="job-actions">
        @switch (actionsType()) {
          @case (jobListItemActionsType.MENU) {
            <button
              mat-icon-button
              class="job-menu-trigger"
              [matMenuTriggerFor]="jobMenu"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #jobMenu="matMenu">
              <a (click)="onDownloadCsvClick()" target="_blank">
                <button mat-menu-item>
                  <span i18n="@@app.labels.downloadCsv"
                    >Download job data (CSV)</span
                  >
                </button>
              </a>

              <a (click)="onDownloadGeoJsonClick()" target="_blank">
                <button mat-menu-item>
                  <span i18n="@@app.labels.downloadGeojson"
                    >Download site locations (GeoJSON)</span
                  >
                </button>
              </a>
            </mat-menu>
          }
          @case (jobListItemActionsType.BACK) {
            <button mat-icon-button aria-label="back" (click)="onGoBackClick()">
              <mat-icon>close</mat-icon>
            </button>
          }
        }
      </div>
    } @else {
      <button
        mat-icon-button
        [attr.aria-expanded]="expanded()"
        [attr.aria-label]="'Toggle ' + job().name"
        (click)="toggleExpanded()"
      >
        <mat-icon
          class="job-icon"
          fontSet="material-icons"
          [style.color]="job().color"
        >
          label
        </mat-icon>
      </button>
    }
  </div>

  @if (expanded()) {
    <!-- Only the visible rows are rendered, so jobs with thousands of LOIs stay fast. -->
    <cdk-virtual-scroll-viewport
      class="loi-list"
      [itemSize]="loiRowHeight"
      [style.height.px]="loiListHeight()"
    >
      <ng-container
        *cdkVirtualFor="let item of loiItems(); trackBy: trackByLoiId"
      >
        @if (isSidePanelExpanded()) {
          <button
            type="button"
            class="loi-tree-node expanded"
            [class.tree-node-selected]="item.loi.id === loiId()"
            [attr.title]="item.name"
            (click)="selectLoi(item.loi)"
          >
            <mat-icon
              [svgIcon]="item.iconName"
              class="loi-icon"
              [style.color]="job().color"
            ></mat-icon>

            <span class="loi-name">{{ item.name }}</span>

            <span class="loi-submission-count">
              {{ item.loi.submissionCount ?? 0 }}
            </span>
          </button>
        } @else {
          <button
            mat-icon-button
            class="loi-collapsed-toggle"
            [class.tree-node-selected]="item.loi.id === loiId()"
            [attr.aria-label]="item.name"
            [attr.title]="item.name"
            (click)="selectLoi(item.loi)"
          >
            <mat-icon
              [svgIcon]="item.iconName"
              class="loi-icon"
              [style.color]="job().color"
            ></mat-icon>
          </button>
        }
      </ng-container>
    </cdk-virtual-scroll-viewport>
  }
</div>
